export default function ($document) {
  return {
    restrict: 'A',
    scope: {
      clickOutside: '&',
    },
    link: function (scope, element) {
      const onClick = function (event) {
        // Проверяем, содержит ли элемент или его родители атрибут data-ignore-click-outside
        const hasIgnoreAttribute = event.target.closest('[data-ignore-click-outside], .ui-select-container');
        
        if (!element[0].contains(event.target) && !hasIgnoreAttribute) {
          scope.$apply(function () {
            scope.clickOutside();
          });
        }
      };
      // Добавляем обработчик кликов на весь документ
      $document.on('click', onClick);

      // Удаляем обработчик при уничтожении директивы
      scope.$on('$destroy', function () {
        $document.off('click', onClick);
      });
    },
  };
}
